import { AccountStatus } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const headTitleList: any[] = [
  { headTitle: "契約者名" },
  { headTitle: "担当者名" },
  { headTitle: "代行者" },
  { headTitle: "ログインID" },
  { headTitle: "ステータス" },
];

const listData: any = [
  {
    keyword: "contractorNo",
    type: "label",
    label: "契約者番号",
    inputProps: {
      maxLength: 6,
    },
  },
  {
    keyword: "corpName",
    type: "label",
    label: "契約者名",
    inputProps: {
      maxLength: 48,
    },
  },
  {
    keyword: "name",
    type: "label",
    label: "担当者名",
    inputProps: {
      maxLength: 48,
    },
  },
  {
    keyword: "useStatus",
    type: "selectFrom",
    label: "ステータス",
    selectPropsList: TkGetCodeList(AccountStatus),
  },
];

const schema = {
  contractorNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "6"),
    },
  },
  corpName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
  name: {
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

export { headTitleList, listData, schema };
